export default {
  userPins: [],
  userPin: undefined,
};
